/* jshint esversion: 8 */
/* jshint node: true */

import React, { useEffect, useState } from "react";
import "./LandingPage.scss";
import ProgramResultsFiguresRow from "./ProgramResultsFiguresRow/ProgramResultsFiguresRow";
import Footer from "components/Footer/Footer";
import jsonFooterConfig from "assets/configs/footer-config.json";
import { useSelector } from "react-redux";
import { selectapp } from "stateMgmt/appSlice";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Link from "@mui/material/Link";
import Collapse from "@mui/material/Collapse";
import { isMobileOnly } from "react-device-detect";
import { isPortrait } from "common";
import Typography from "@mui/material/Typography";
import IndiaFootnote from "components/IndiaFootnote/IndiaFootnote";

const mainContent = (props) => {
  const theme = useSelector(selectapp).theme;
  const appContext = useSelector(selectapp).context;
  const [isHidden, setIsHidden] = useState(false);
  const [open, setOpen] = useState(true);

  let mainContentCssClasses =
    "landing-page__main landing-page__main__left-margin left-margin-wide-monitors";
  if (props.isSidebarCollapsed) {
    mainContentCssClasses = mainContentCssClasses.replace(
      "landing-page__main__left-margin",
      "landing-page__main__closed-margin",
    );
    mainContentCssClasses = mainContentCssClasses.replace(
      "left-margin-wide-monitors",
      "",
    );
  }

  useEffect(() => {
    const hide = appContext !== "home";
    setIsHidden(hide);
    setOpen(isMobileOnly && isPortrait);
  });

  // FORMAT: landing-page__container (HTML)
  return (
    <div
      id="mainContent"
      style={{ backgroundColor: theme.backgroundColor, color: theme.color }}
      className={mainContentCssClasses}
      role="main"
      tabIndex={-1}
    >
      <Collapse in={open}>
        <Alert
          severity="warning"
          sx={{ fontSize: "1.0rem", fontWeight: 800 }}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon sx={{ fontSize: "24px" }} />
            </IconButton>
          }
        >
          This site is best viewed in landscape mode.
        </Alert>
      </Collapse>

      <Typography variant="body1">        
       The <Link
                  variant="body2"
                  underline="hover"
                  style={{ color: theme.linkColor, fontWeight: 500 }}
                  href="https://www.state.gov/releases/bureau-of-global-health-security-and-diplomacy/2026/04/spotlight-fy25-quarter-four-public-data-release-pepfar-continues-support-for-over-20-million-living-with-hiv-and-more-than-doubles-number-of-pregnant-and-breastfeed/"
                  target="_blank"
                > U.S. Department of State's Bureau of Global Health Security and Diplomacy (GHSD) is pleased to release </Link>
      
       PEPFAR program data for the fourth quarter of FY 2025. As in prior years, these data do not represent comprehensive national HIV program results for countries but instead only data from PEPFAR-funded partners providing service delivery and technical assistance. The U.S. government has greater confidence in fourth quarter data completeness following the transition of global health programs to the Department of State; earlier quarters experienced reporting and implementation challenges which limit data interpretability. Future routine program data reporting and annual public data release across all health assistance areas will be aligned with bilateral health Memorandums of Understanding. GHSD will work to strengthen and utilize country government reporting systems to advance country self-reliance and health sovereignty.
      </Typography>

      <br/>

      <Typography variant="h2" id="page-heading" role="heading"
                  // className="centered-text"
                  tabIndex={0} style={{
        color: theme.section,
      }}>
        About PEPFAR
      </Typography>

      <Typography variant="body1">
        Through the President’s Emergency Plan for AIDS Relief (PEPFAR), the
        U.S. government has made the largest commitment by any nation to address
        a single disease in history - saving 26 million lives, enabling 7.8
        million babies to be born HIV-free, preventing millions of HIV
        infections, and accelerating progress toward controlling the global
        HIV/AIDS pandemic in more than 50 countries.
      </Typography>

      <br/>

      <Typography variant="h2" id="page-heading" role="heading"
                  // className="centered-text"
                  tabIndex={0} style={{
                    color: theme.section,
      }}>
        About PEPFAR Panorama Spotlight
      </Typography>

      <Typography variant="body1">
        Program results are available in the
        <Link
          variant="body2"
          underline="hover"
          style={{ color: theme.linkColor, fontWeight: 600 }}
          href="/dashboard"
          title="Link TO Spotlight Dashboard"
          aria-label="Link TO Spotlight Dashboard"
        >
          PEPFAR Panorama Spotlight Dashboard
        </Link>{" "}

        and as

        <Link
          variant="body2"
          underline="hover"
          style={{ color: theme.linkColor, fontWeight: 600 }}
          href="/datasets"
          title="Link TO downloadable datasets"
          aria-label="Link TO downloadable datasets"
        >
        downloadable datasets.
        </Link>{" "}

        For FY25 Monitoring, Evaluation, and Reporting (MER) data, Q4 results are included in the Spotlight dashboard and datasets. Data should be analyzed and interpreted accordingly. To learn more about PEPFAR data, see the 


        <Link
          variant="body2"
          underline="hover"
          style={{ color: theme.linkColor, fontWeight: 600 }}
          href="/user_guide"
          title="Link TO User Guide"
          aria-label="Link TO User Guide"
        >
        Spotlight User Guide.
        </Link>

       
      </Typography>

      <div className="container-fluid landing-page__container">
        <div>
          <ProgramResultsFiguresRow />
        </div>

        <div className="row" id="footer_row_iata">
          <div
            className="col-12"
            style={{
              backgroundColor: theme.backgroundColor,
              color: theme.color,
              fontSize: "1.3vh",
            }}
          >
            <IndiaFootnote isHidden={isHidden} />

            <Box
              sx={{ fontSize: "0.6rem" }}
              tabIndex={isHidden ? -1 : 1}
              role="note"
            >
              Unless otherwise noted, the content, data, documentation, code,
              and related materials on data.pepfar.gov is public domain and made
              available with a{" "}
              <a
                href="http://creativecommons.org/publicdomain/zero/1.0/legalcode"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: theme.linkColor }}
                aria-hidden={isHidden}
                tabIndex={isHidden ? "-1" : 1}
              >
                Creative Commons CC0 1.0 Universal
              </a>{" "}
              dedication and license-free (per US Code{" "}
              <a
                href="http://www.gpo.gov/fdsys/pkg/USCODE-2010-title17/html/USCODE-2010-title17-chap1-sec105.htm"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: theme.linkColor }}
                aria-label="Title 17 section 105 subject matter of copyright"
                aria-hidden={isHidden}
                tabIndex={isHidden ? "-1" : 1}
              >
                17 USC § 105
              </a>
              ). Data.pepfar.gov waive all rights to the work worldwide under
              copyright law, including all related and neighboring rights, to
              the extent allowed by law. You can copy, modify, distribute, and
              perform the work, even for commercial purposes, all without asking
              permission. Citation of data.pepfar.gov as a source of the data is
              appreciated.
            </Box>
          </div>
        </div>

        <div>
          <Footer footerConfig={jsonFooterConfig} />
        </div>
      </div>
    </div>
  );
};

export default mainContent;
